/* eslint-disable */
import * as axios from "axios";
import { AxiosResponse, AxiosRequestConfig } from "axios";
import { MaskModule, ConfigModule } from "@/store/index";

/* 创建axios实例 */
const service = axios.default.create({
  timeout: 1000 * 60,
  baseURL: process.env.VUE_APP_API_URL
});

service.interceptors.request.use((config: AxiosRequestConfig) => {
  return config;
}, (error: any) => {
  Promise.reject(error);
});

service.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data;
  },
  (error: any) => {
    const errorCode = error.response.data.meta.error.code;
    const errorMsg = (ConfigModule as any)[`categoryForError_${errorCode}`];    // eslint-disable-line
    
    MaskModule.alertMask(errorMsg || errorCode);
    return Promise.reject(error);
  });

export default service;
